import { ListIcon } from "components/icons"
import { Button } from "@mui/material"
import { useTranslation } from "providers/i18n"

export const StepButton = ({ label = "Step", ...props }) => {
  const { t } = useTranslation()

  return (
    <Button variant="outlined" startIcon={<ListIcon />} {...props}>
      {t(label)}
    </Button>
  )
}
